import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';
import PublicLayout from '../components/layout/PublicLayout';
import { Button } from '../components/ui/button';

export default function About() {
  return (
    <PublicLayout>
      <SEOHead
        title="À propos de Clairify — IA Business Intelligence pour PME | STELLARMEET SAS"
        description="Clairify (STELLARMEET SAS, Paris 8e) développe une IA business intelligence pour PME : Memory Layer, Pattern Collisions, système multi-agents. Hébergé en France, conforme RGPD."
        keywords={['Clairify à propos', 'STELLARMEET SAS', 'startup IA France', 'IA PME Paris']}
      />

      <section className="pub-hero">
        <p className="home-kicker">À propos</p>
        <h1>Clarifier, pas extraire.</h1>
        <p>
          Chaque entreprise devrait pouvoir lire ses données —
          sans tableau de bord cosmétique, sans oublier à chaque session.
        </p>
      </section>

      <section className="pub-wrap" style={{ maxWidth: '42rem', marginLeft: 0 }}>
        <p className="home-kicker">Mission</p>
        <h2 className="font-display text-3xl mb-4">Notre mission</h2>
        <p className="text-theme-secondary font-light leading-relaxed mb-16">
          Clairify démocratise l'intelligence artificielle dans l'analyse de données.
          Une mémoire persistante. Des collisions nommées. Des décisions.
          Pour les PME, pas seulement les groupes.
        </p>

        <p className="home-kicker">Ce qu'elle fait</p>
        <div className="pub-grid" style={{ marginBottom: '4rem' }}>
          <article className="pub-card">
            <span>01</span>
            <h3>Memory Layer</h3>
            <p>Une mémoire persistante de votre business. Elle ne repart jamais de zéro.</p>
          </article>
          <article className="pub-card">
            <span>02</span>
            <h3>Collisions</h3>
            <p>Deux vérités qui s'annulent. Elle les croise, les chiffre, les nomme.</p>
          </article>
          <article className="pub-card">
            <span>03</span>
            <h3>Multi-agents</h3>
            <p>Un orchestre : détection, maturité, orchestration. Pas un modèle unique.</p>
          </article>
        </div>

        <p className="home-kicker">France</p>
        <h2 className="font-display text-3xl mb-4">Souveraineté</h2>
        <p className="text-theme-secondary font-light leading-relaxed mb-10">
          Hébergement Scaleway, Paris. RGPD. Chiffrement. Hors Cloud Act.
          Vos données restent ici.
        </p>

        <p className="home-kicker">Société</p>
        <h2 className="font-display text-3xl mb-4">STELLARMEET SAS</h2>
        <p className="text-theme-secondary font-light leading-relaxed mb-2">Capital 1 000 € · SIREN 935 065 094</p>
        <p className="text-theme-secondary font-light leading-relaxed mb-16">25 rue de Ponthieu, 75008 Paris · 30 octobre 2024</p>

        <div className="pub-cta" style={{ textAlign: 'left', paddingLeft: 0 }}>
          <h2>Une question ?</h2>
          <p>Écrivez-nous. Réponse sous 24–48 h.</p>
          <Link to="/contact">
            <Button size="lg">Contact</Button>
          </Link>
        </div>
      </section>
    </PublicLayout>
  );
}
